<mat-sidenav-container class="sidenav-container" autosize>
    <mat-sidenav-content class="relleno">
        <mat-toolbar class="toolbar-main px-5 py-2" autosize>
            <app-toolbar class="w-100"></app-toolbar>
        </mat-toolbar>
        <div class="container-page">
            <app-benefitsSider></app-benefitsSider>
            <router-outlet></router-outlet>
            <app-footer class="w-100"></app-footer>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>